<!-- eslint-disable -->
<template lang="pug">
    .battle-create__block
        .battle-create-form
            template(v-if="isShowForm")
                .battle-create-form__header
                    div(slot="title") {{ $i18n.t('battle.battle_form_createBattle') }}
                battle-form
            div(v-else) {{ $i18n.t('common.common_textInfo_pageNotAllowed') }}
</template>

<script>
    /*eslint-disable*/
    import BoxHeader from '../../elements/BoxHeader.vue';
    import BattleForm from './BattleForm.vue';
    import { mapState } from 'vuex';

    export default {
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            isShowForm () {
                return this.user.isSuperadmin || this.user.isManagerOrSupport;
            }
        },
        components: {
            BoxHeader,
            BattleForm,
        }
    }
</script>

<style lang="scss" scoped>
    .battle-create__block {
        background-color: $x-color-white;
        @include media($sm) {
            border-radius: 40px;
            padding: 28px 30px;}
    }
    .battle-create-form {
        margin: 0;
        padding: 20px;
        height: 100%;
        background-color: $hsl-color-gray-98;
        box-sizing: border-box;border-radius: 20px;
        @include media($md) {
            padding: 30px;
        }
        @include media($lg) {
            padding: 30px 15% 30px 15%;
        }
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    .battle-create-form__header {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 25px;
    }
</style>
